import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter, getStaticData } from '../../../../store/actions/sportEvents';
import Categories from '../../../shared/Events/Filters/Categories/Categories';
import Leagues from '../../../shared/Events/Filters/Leagues/Leagues';
import Periods from '../../../shared/Events/Filters/Periods/Periods';
import Orders from '../../../shared/Events/Filters/Orders/Orders';
import MainMarkets from '../../../shared/Events/Table/MainMarkets/MainMarkets';
import { EVENT_FILTER_OPTIONS } from '../../../../constants/event-filters';
import EventType from '../../../shared/Events/Filters/EventType/EventType';
import { EVENT_TYPE_ENUM } from '../../../../constants/enums';

const PreMatchFilters = props => {
    const dispatch = useDispatch();

    const categories = useSelector(state => state.sportEvents.filters.categories) || [];
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];
    const { sportRefId, isLive, isESports, eventType } = useSelector(state => state.sportEvents);

    const isOutrightsSelected = useMemo(
        () => eventType.value === EVENT_TYPE_ENUM.outright,
        [eventType]
    );

    const onCategoriesChange = value => {
        const newLeagues = leagues.map(league => ({
            ...league,
            selected: league.id === EVENT_FILTER_OPTIONS.leagues.all.id,
        }));

        dispatch(changeEventFilter({ key: 'leagues', value: newLeagues }));
    };

    const onLeaguesChange = value => {
        if (value.categoryId) {
            const newCategories = categories.map(category => ({
                ...category,
                selected: category.id === value.categoryId,
            }));

            dispatch(changeEventFilter({ key: 'categories', value: newCategories }));
        }
    };

    const onPeriodChange = period => {
        let startDate, endDate;

        if (period.id !== 'all') {
            const { startTime, endTime } = period.getRange();
            startDate = startTime;
            endDate = endTime;
        }

        dispatch(
            getStaticData({
                sportTypeId: sportRefId,
                live: isLive,
                startDate,
                endDate,
                isESports,
            })
        );
    };

    return (
        <>
            <div className={'filter-area'}>
                {!isESports && (
                    <div className={'filter-grid'} style={{ width: '40%' }}>
                        <EventType />
                    </div>
                )}
                <div className={'filter-grid'} style={{ width: '80%' }}>
                    <Categories onChange={onCategoriesChange} />
                </div>
                <div className={'filter-grid'}>
                    <Leagues onChange={onLeaguesChange} />
                </div>
                {!isOutrightsSelected && (
                    <div className={'filter-grid'} style={{ width: '60%' }}>
                        <Periods onChange={onPeriodChange} />
                    </div>
                )}
                <div className={'filter-grid'} style={{ width: '60%' }}>
                    <Orders />
                </div>
                {/*<div className={'filter-grid'} style={{ width: '90px', minWidth: '90px' }} />*/}
            </div>
            {!isOutrightsSelected && <MainMarkets />}
        </>
    );
};

export default PreMatchFilters;
